import React, { useRef } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { updatedata, add_newdata } from "../Redux/reduxflow/action";
import baseUrlNew from "../BaseUrl/index";
import { videoSteps } from "../CameraWithOverlayVideo/data";
import ReactPlayer from "react-player";
import video from "../assets/hatchback-v3-1104x828-30fps.webm";
import video_android from "../assets/hatchback-v3-1104x828-30fps.webm";
import NativeInspectionCamera from "../components/NativeInspectionCamera";
import { exitImmersiveMode } from "../utils/immersiveMode";
import { toast } from "react-toastify";
import "../CameraWithOverlayVideo/styles.css";

function Camra2({
  setcamra_open,
  imge_categary,
  img_type,
  add_newdata,
  index_of_data,
  id,
}) {
  const videoPlayer = useRef(null);
  const [playVideo, setplayVideo] = React.useState(true);
  const requestRef = React.useRef();
  const previousTimeRef = React.useRef(true);
  const arr = [].concat.apply([], Object.values(videoSteps));
  const step = arr[index_of_data] || arr[0];
  const guideUrl =
    window.navigator.platform === "iPhone" ? video : video_android;

  const seekToStep = () => {
    if (!videoPlayer.current || !step) return;
    const t = Math.max(0, Number(step.start_at) || 0);
    try {
      videoPlayer.current.seekTo(t, "seconds");
    } catch {
      /* ignore */
    }
  };

  const animate = () => {
    if (previousTimeRef.current && videoPlayer.current && step) {
      const getCurrentTime = videoPlayer.current.getCurrentTime();
      const start = Number(step.start_at) || 0;
      const stop = Number(step.stop_at) || start;
      if (getCurrentTime >= start && getCurrentTime <= stop + 0.2) {
        previousTimeRef.current = false;
        setplayVideo(false);
      }
    }
    requestRef.current = requestAnimationFrame(animate);
  };

  React.useEffect(() => {
    previousTimeRef.current = playVideo;
  }, [playVideo]);

  React.useEffect(() => {
    seekToStep();
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const baseUrl = `${baseUrlNew.baseUrl}api/v1/product_images/`;

  const closeCamera = async () => {
    await exitImmersiveMode();
    setcamra_open(false);
  };

  const onCapture = async (imageSrc) => {
    try {
      const response = await axios.post(baseUrl, {
        name: imge_categary,
        type: img_type,
        image_data: imageSrc,
        evaluate_image: id,
      });
      add_newdata(response.data.data);
      await exitImmersiveMode();
      setcamra_open(false);
    } catch (err) {
      toast.error("Could not upload this photo. Please try again.");
      throw err;
    }
  };

  return (
    <NativeInspectionCamera
      onCapture={onCapture}
      onCancel={closeCamera}
      captureEnabled={!playVideo}
      cancelLabel="Cancel"
      hint="Match the guide pose, then capture."
      rotateDescription="Hold your phone horizontally to add this photo. Cancel returns to the photo grid."
      titleBar={imge_categary}
      overlay={
        <div className="video_wrapper pi-camera-guide" style={{ pointerEvents: "none" }}>
          <ReactPlayer
            ref={videoPlayer}
            playing={playVideo}
            playbackRate={4}
            width="92%"
            height="92%"
            playsinline
            muted
            url={guideUrl}
            onReady={seekToStep}
            config={{
              file: {
                attributes: {
                  playsInline: true,
                  muted: true,
                },
              },
            }}
          />
        </div>
      }
    />
  );
}

const mapStateToProps = (state) => ({
  car_data: state.cardata.car_pics_data,
  loading: state.cardata.loading,
});
const mapDispatchToProps = (dispatch) => {
  return {
    updatedata: (response, variant_id) =>
      dispatch(updatedata(response, variant_id)),
    add_newdata: (data) => dispatch(add_newdata(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Camra2);
